module.exports = __webpack_public_path__ + "static/media/screen_share_off.a3ef917e.svg";